module.exports = __webpack_public_path__ + "static/media/2_2.1994dbc8.png";